import { gql } from "@apollo/client";

export const QUERY_CHARACTER_AWARENESS_DAYS_CALENDAR_PAGE_V5 = gql`
  query characterAwarenessDaysCalendarPageV5 {
    calendarPage {
      documentId
      title
      description
      downloadButtonText
      file {
        url
      }
      calendarFeedbackMessage {
        calendarPermissionDenied
        calendarNotFound
        eventAlreadyExists
        eventAddedSuccessGoogle
        eventAddedSuccessApple
        eventAddedSuccessGeneric
      }
      NoDaysMonthText
      monthThemesTitle
    }
  }
`;

export const QUERY_CALENDAR_BY_YEAR_V5 = gql`
  query calendarByYearV5($year: Int!) {
    calendars: calendars_connection(filters: { year: { eq: $year } }) {
      nodes {
        year
        eventDays {
          startDate
          name
          wholeMonth
          description
          endDate
          related_knowledge_base {
            slug
          }
        }
      }
    }
  }
`;
